// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + {"12":"profiler","777":"recorder"}[chunkId] + "-" + {"12":"9b362e2387c00f7762f7","777":"5ad025e7ff0571b84fb6"}[chunkId] + ".chunk.js";
};